var _defs, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgArrowRightRoundedBorders(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "0%",
    y1: "50%",
    x2: "100%",
    y2: "50%",
    id: "71t5wlam3a"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#30ACC1",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3077C1",
    offset: "100%"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 0c6.627 0 12 5.372 12 12 0 6.627-5.373 12-12 12S0 18.627 0 12 5.373 0 12 0zm0 1.92C6.442 1.92 1.92 6.442 1.92 12S6.442 22.08 12 22.08 22.08 17.558 22.08 12 17.558 1.92 12 1.92zm2.826 5.065 2.5 3 .023.028.02.026.003.006-.005-.006.012.016.035.054a.92.92 0 0 1 .034.06l.023.05.026.063a.889.889 0 0 1 .047.177l.005.038a.937.937 0 0 1 .007.072l.001.026v.025a1.002 1.002 0 0 1-.007.134l-.006.037a.926.926 0 0 1-.03.128l-.017.049-.025.064a.964.964 0 0 1-.057.109l-.028.043a.875.875 0 0 1-.061.081l-2.5 3a1 1 0 1 1-1.537-1.28l.924-1.11h-.905a4.5 4.5 0 0 0-4.5 4.5 1 1 0 1 1-2 0 6.5 6.5 0 0 1 6.5-6.5h1.323l-1.342-1.61a1 1 0 0 1 1.537-1.28z",
    fill: "",
    fillRule: "nonzero"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRightRoundedBorders);
export default __webpack_public_path__ + "static/media/arrow-right-rounded-borders.598790cbe9718eb4a212e766dbe38504.svg";
export { ForwardRef as ReactComponent };